import React, { Component, Fragment } from "react";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
var HtmlToReactParser = require('html-to-react').Parser;
var htmlToReactParser = new HtmlToReactParser();

class ArticleWritingMain extends Component  {

  constructor(props) {
    super(props);
    this.state = {
      text: "",
      reactElement: null,
    }

    this.editorRef = React.createRef();
  }

  modules = {
    toolbar: [
      [{ 'header': [1, 2, false] }],
      ['bold', 'italic', 'underline','strike', 'blockquote'],
      [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
      ['link', 'image'],
      ['clean']
    ],
  }

  formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image'
  ]

  async onChangeArticle(data) {
    console.log(data.toString());
    let text = data.toString();
    try {
      console.log(this.state.text);
      this.setState({text});
      
      var reactElement = htmlToReactParser.parse(text);
      console.log(reactElement);
      this.setState({reactElement});
      // Parser.parse(text);
    } catch (error) {
      console.log(error)
    }
  }

  render () {
    return (
      <Fragment>
          <div className="content-header">
              <h1>Article Writing</h1>
              <Link to={"/admin/advertisement/add"}>
                  <Button variant="contained">Add New</Button>
              </Link>
          </div>
          {/* <ListAd /> */}
          <div dangerouslySetInnerHTML={{__html: 'First &middot; Second'}} />
          <ReactQuill 
            ref={this.editorRef}
            theme="snow" 
            modules={this.modules} 
            formats={this.formats}
            defaultValue={this.state.value}
            onChange={(content, delta, source, editor) => this.onChangeArticle(content)}
          />
          <div>Html={this.state.text}</div>
          <div>Display:</div>
          {this.state.reactElement}
      </Fragment>
    );
  }
};

export default ArticleWritingMain;
